import AddIcon from '@mui/icons-material/Add';
import styles from './Fab.module.scss';

/*
 * הפעולה הראשית של הלוח במסך צר, בשתי הצורות שהמקור נותן לה
 * (hatzdaka-nedarim): כפתור צף שנשאר במקומו לאורך הגלילה, וכרטיס
 * עם תווית שיושב מעל הרשימה ומסביר מה הפעולה.
 *
 * שניהם קוראים לאותו onClick — זו אותה פעולה, לא שתיים.
 */

interface FabProps {
  label: string;
  onClick: () => void;
}

/** הכפתור הצף. מוסתר מעל 1100, שם הפעולה חוזרת ל-chrome של הלוח. */
export const Fab = ({ label, onClick }: FabProps) => (
  <button type="button" className={styles.fab} title={label} aria-label={label} onClick={onClick}>
    <AddIcon sx={{ fontSize: 26 }} />
  </button>
);

/** הכרטיס שמעל הרשימה. מרונדר רק כשהעמוד מחליט שהוא במסך צר. */
export const FabActionCard = ({ label, onClick }: FabProps) => (
  <button type="button" className={styles.actionCard} onClick={onClick}>
    <span className={styles.actionCardPlus} aria-hidden="true">
      +
    </span>
    {label}
  </button>
);
